import useSWR from 'swr';
import { serializeKey } from '@/utils/swr/keys';

export function useProductListTabState(uniqueId: string) {
  // 构造合规的 Local Key，确保不会与 API 缓存冲突
  const TAB_STATE_KEY = serializeKey(['local', 'ui', 'productListTab', uniqueId]);

  // 1. fetcher 传 null，明确不发请求
  // 2. 彻底禁用所有自动 revalidate 行为
  const { data, mutate } = useSWR<string>(TAB_STATE_KEY, null, {
    fallbackData: '1',
    revalidateOnMount: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    revalidateIfStale: false,
  });

  // 封装 actions
  const setClickTab = (tab: string) => {
    // 3. Mutate 必须带上 revalidate: false
    mutate(tab, { revalidate: false });
  };

  return {
    clickTab: data!, // 断言不为空，因为我们提供了 fallbackData
    setClickTab,
  };
}
